$(document).ready(function(){
		
		$(window).load(function () {
				$('.loading').delay(400).fadeOut(1000);
				$('body').addClass('open');
		});
		
		$(function() {
				$(".sub_grand_menu_top").click(function(){
						$(".sub_grand_menu_top .button-navi-icon").addClass("close");
						$(".button-close").css('z-index', '9999');
						$("#menu_index").fadeIn();
						$(".menu_back").fadeIn();
						$('#menu_index').addClass("active");
						$(".sp_logo").fadeOut();
						$('#sp_header').removeClass("active");
						$("#main_logo").fadeOut();
						$('#top_media_banner').fadeOut();
						$('.header_cart_btn').addClass("active");
				});
		});
		
		
		$(function() {
				$(".button-close, .menu_back").click(function(){
						$(".sub_grand_menu_top .button-navi-icon").removeClass("close");
						$(".button-close").css('z-index', '-9999');
						$("#menu_index").fadeOut(1000);
						$(".menu_back").fadeOut();
						$('#menu_index').removeClass("active");
						$('#sp_header').addClass("active");
						$("#main_logo").delay(1000).fadeIn();
						$('#top_media_banner').delay(1000).fadeIn();
						$('.header_cart_btn').removeClass("active");
				});
		});
		
		
		
		$(function(){
			$('.ancher_menu_sp').on('click', function(){
					var box = $(this).next('.a_menu_list');
					box.slideToggle(300);
					$(this).toggleClass('active');
				});
				
		});
		
		
		
		$('.a_menu_list a, .ancher').click(function(){
				var target = $(this.hash);
				//$(this).text(target.length+"/");
				if (target) {
					var targetOffset = target.offset().top;
					$('html,body').animate({scrollTop: targetOffset},1400,"easeInOutQuint");
				return false;}
		});
		
		
		
		$(function() {
    if (window.innerWidth <= 768) {
        $(".a_menu_list a").click(function(){
            $(".ancher_menu_sp").toggleClass('active');
            $(".a_menu_list").slideToggle();
        });
    }
});
		
		
		
		$(window).on('scroll',function(){
				var winPosTop = $(window).scrollTop();
				if(winPosTop >= 300){
					$("body").addClass("active");
				} else if(winPosTop < 300){
					$("body").removeClass("active");
				}
				
		});
		
		
		
		
		
		$('.page_top_btn a').click(function(){
				var target = $(this.hash);
				//$(this).text(target.length+"/");
				if (target) {
					var targetOffset = target.offset().top;
					$('html,body').animate({scrollTop: targetOffset},1400,"easeInOutQuint");
				return false;}
		});
		
		
	});
	
	
	$(function(){$(window).scroll(function(){
				$(".sc_ani").each(function(){var n=$(this).offset().top,e=$(window).scrollTop(),o=$(window).height();e>n-o+-100&&$(this).addClass("active")
				})
		})
	});













